import {PivotConfig, PivotSlice, PivotDataField, PivotDice, Pivot} from './PivotConfig';
import {MapKey} from './MapKey';
import {element} from 'protractor';

export class PivotReportPOJO {

  config: PivotConfig;
  data: PivotData;

  constructor(pojo: PivotReportPOJO, config: PivotConfig, raw: any[], aggregations: any[]) {
    if (pojo) {
      this.config = pojo.config;
      this.data = pojo.data;
    } else {
      this.config = config;
      this.data = {
        raw: raw,
        aggregation: aggregations
      };
    }
  }

}

export class PivotReport extends PivotReportPOJO {


  private static powerSet(input: any[]) {
    if (input.length === 0) return [input];

    let first = input[0];
    let rest = PivotReport.powerSet(input.slice(1));

    let tmp = rest.map(el => [first].concat(el));

    return tmp.concat(rest);
  }

  private static nullPowerSet(input: any[]) {
    let keyCombinationsWithoutNull = this.powerSet(input);
    let nullPowerSet = [];
    for (let combination of keyCombinationsWithoutNull) {
      let nulledCombination = [];
      let powerSetPos = 0;
      for (let col = 0; col < input.length; col++) {
        let powerSetElement = powerSetPos < combination.length ? combination[powerSetPos] : null;
        let colValue = input[col];
        if (powerSetElement == null || powerSetElement != colValue) {
          nulledCombination.push(null);
        } else {
          nulledCombination.push(powerSetElement);
          powerSetPos++;
        }
      }
      nullPowerSet.push(nulledCombination);
    }
    return nullPowerSet;
  }


  public static fromConfig(reportConfig: PivotConfig): PivotReport {
    let data = reportConfig.dataSource.data;
    let allKnownFields = {};
    for (let row of data) {
      for (let col in row) {
        allKnownFields[col] = col;
      }
    }
    for (let row of data) {
      for (let col in allKnownFields) {
        if (row[col] === undefined) {
          row[col] = Pivot.EMPTY_VALUE;
        }
      }
    }

    let mapped: Map<string, any[]> = new Map();
    let mapKeys: Map<string, MapKey> = new Map();
    for (let row of data) {
      let key = MapKey.fromPivot(reportConfig.slice.rows, reportConfig.slice.columns, row);
      let entries = mapped.get(key.toString());
      if (!entries) {
        entries = [];
        mapped.set(key.toString(), entries);
        mapKeys.set(key.toString(), key);
      }
      entries.push(row);
    }

    let aggregations: Map<string, any> = new Map();
    mapped.forEach((value, key) => {
      let aggregation = [];
      for (let measure of reportConfig.slice.measures) {
        let measureData = [];
        for (let row of value) {
          measureData.push(row[measure.fieldName]);
        }
        aggregation.push(measure.aggregation._func(measureData));
      }
      aggregations.set(key, aggregation);
    });


    let combinations: Map<string, MapKey> = new Map();
    /*for (let key of mapKeys.values()) {
        let keyData = key.getKeyData();
        let keyCombinations = PivotReport.nullPowerSet(keyData);
        for (let combination of keyCombinations) {
            let mapKey: MapKey = MapKey.fromArray(combination)
            if (!combinations.has(mapKey.toString()))
                combinations.set(mapKey.toString(), mapKey);
            //else
            //  console.log("Skipping "+mapKey.toString());
        }
    }


    console.log(combinations.size);

    combinations = new Map();
    */
    let combinationValues: Map<string, any[]> = new Map();

    for (let key of mapKeys.values()) {
      let keyData = key.getKeyData();
      let data = aggregations.get(key.toString());
      let keyCombinations = Combination.nullPermutations(keyData);
      for (let combination of keyCombinations) {
        let mapKey: MapKey = MapKey.fromArray(combination)
        if (!combinations.has(mapKey.toString())) {
          combinations.set(mapKey.toString(), mapKey);
        }
        let combinationData = combinationValues.get(mapKey.toString());
        if (!combinationData) {
          combinationData = [];
          combinationValues.set(mapKey.toString(), combinationData);
        }
        combinationData.push(data);
        //else
        //  console.log("Skipping "+mapKey.toString());
      }
    }

    let fieldAggregations: Map<string, any[]>[] = [];
    /*populate array*/
    for (let entry of aggregations.entries()) {
      let key = entry[0];
      let keyData = mapKeys.get(key).getKeyData();
      for (let field = 0; field < keyData.length; field++) {
        fieldAggregations[field] = new Map();
      }
      break;
    }
    /*populate array*/

    for (let entry of aggregations.entries()) {
      let key = entry[0];
      let keyData = mapKeys.get(key).getKeyData();
      for (let field = 0; field < keyData.length; field++) {
        let fieldVal = JSON.stringify(keyData[field]);
        let data = fieldAggregations[field].get(fieldVal);
        if (!data) {
          data = [];
          fieldAggregations[field].set(fieldVal, data);
        }
        data.push(entry);
      }
    }

    let combinationAggregations: Map<string, any> = new Map();

    for (let entry of combinationValues.entries()) {
      let combinationKey = entry[0];
      let matches = entry[1];
      let combinationMapKey = combinations.get(combinationKey);
      let combinationMapKeyArray = combinationMapKey.getKeyData();

      let aggregation = [];
      let measurePos = 0;
      for (let measure of reportConfig.slice.measures) {
        let measureData = [];
        for (let row of matches) {
          measureData.push(row[measurePos]);
        }
        aggregation.push(measure.aggregation._func(measureData));
        measurePos++;
      }
      combinationAggregations.set(combinationKey, aggregation);

      /*  if (combinationAggregations.size % 1000 == 0) {
            console.log(combinationAggregations.size * 100 / combinations.size + "% calculated...");
        } */
    }

    for (let entry of combinationAggregations) {
      aggregations.set(entry[0], entry[1]);
      mapKeys.set(entry[0], combinations.get(entry[0]));
    }

    let aggregationObjects = [];
    for (let entry of aggregations.entries()) {
      let key = entry[0];
      let value = entry[1];
      let mapKey = mapKeys.get(key);

      let theObject = {};
      for (let row = 0; row < reportConfig.slice.rows.length; row++) {
        let rowKey = mapKey.getKeyData()[row];
        if (rowKey != null) {
          theObject["r" + row] = rowKey;
        }
      }
      for (let col = 0; col < reportConfig.slice.columns.length; col++) {
        let colKey = mapKey.getKeyData()[reportConfig.slice.rows.length + col];
        if (colKey != null) {
          theObject["c" + col] = colKey;
        }
      }
      for (let val = 0; val < reportConfig.slice.measures.length; val++) {
        let valEntry = value[val];
        if (valEntry != null) {
          theObject["v" + val] = valEntry;
        }
      }
      if (Object.keys(theObject).length > 0)
        aggregationObjects.push(theObject);
    }

    return new PivotReport(null, reportConfig, data, aggregationObjects);
  }

  public static loadPOJO(pojo: PivotReportPOJO): PivotReport {
    return new PivotReport(pojo, null, null, null);
  }

  private constructor(pojo: PivotReportPOJO, config: PivotConfig, raw: any[], aggregations: any[]) {
    super(pojo, config, raw, aggregations);
  }

  private findField(slice: PivotDice): string {
    if (slice) {
      if (slice.row) {
        for (let r = 0; r < this.config.slice.rows.length; r++) {
          if (slice.row.fieldName == this.config.slice.rows[r].fieldName)
            return "r" + r;
        }
      }
      if (slice.column) {
        for (let c = 0; c < this.config.slice.columns.length; c++) {
          if (slice.column.fieldName == this.config.slice.columns[c].fieldName)
            return "c" + c;
        }
      }
    }
    return null;
  }

  private findFields(slices: PivotSlice[]): any {
    let fieldSelector = {};
    for (let slice of slices) {
      let field = this.findField(slice);
      if (field != null) {
        fieldSelector[field] = slice.element;
      }
    }
    return fieldSelector;
  }

  public getAggregationData() {
    return this.data.aggregation;
  }

  public getRawData(): any[] {
    return this.getSlicedRawData([]);
  }

  public getSlicedRawData(slices: PivotSlice[]): any[] {
    if (!slices)
      throw new Error("please provide slices array to retrieve data");
    let sliced = [];
    for (let row of this.data.raw) {
      let matches = true;
      for (let slice of slices) {
        let field = slice.column ? slice.column.fieldName : (slice.row ? slice.row.fieldName : null);
        if (field && row[field] !== slice.element) {
          matches = false;
          break;
        }
      }

      if (matches)
        sliced.push(row);
    }
    return sliced;
  }

  public getDataSlices(slices: PivotSlice[]): any[] {
    return this._getDataSlices(slices, false, null);
  }

  public getSlicedDataBy(slices: PivotSlice[], by: PivotDice[]): any[] {
    return this._getDataSlices(slices, false, by);
  }

  public getSlicedData(slices: PivotSlice[]): any {
    return this._getDataSlices(slices, true, null)[0];
  }

  private _getDataSlices(slices: PivotSlice[], exactMatch: boolean, by: PivotDice[]): any[] {
    if (!slices)
      throw new Error("please provide slices array to retrieve data");
    let aggregations = this.data.aggregation;
    let fieldsObject = this.findFields(slices);
    let fieldsObjectKeys = Object.keys(fieldsObject);
    let matches = [];
    let byFields = by == null ? null : [];
    if (byFields) {
      for (let element of by) {
        byFields.push(this.findField(element));
      }
    }
    for (let aggregation of aggregations) {
      let match = true;
      for (let key of fieldsObjectKeys) {
        let a = JSON.stringify(aggregation[key]);
        let b = JSON.stringify(fieldsObject[key]);
        if (a !== b) {
          match = false;
          break;
        }
      }
      if (match) {
        if (exactMatch || byFields != null) {
          let aggregationKeys = Object.keys(aggregation);
          for (let key of aggregationKeys) {
            let keyType = key.substr(0, 1);
            if (keyType === 'c' || keyType === 'r') {
              if (byFields == null) {
                let a = JSON.stringify(aggregation[key]);
                let b = JSON.stringify(fieldsObject[key]);
                if (a !== b) {
                  match = false;
                  break;
                }
              } else {
                let inBy = byFields.indexOf(key) !== -1;
                if (inBy) {
                  if (aggregation[key] == null || aggregation[key] === undefined) {
                    match = false;
                    break;
                  }
                } else {
                  let a = JSON.stringify(aggregation[key]);
                  let b = JSON.stringify(fieldsObject[key]);
                  if (a !== b) {
                    match = false;
                    break;
                  }
                }
              }
            }
          }
        }
        if (match) {
          if (byFields != null) {
            for (let field of byFields) {
              if (aggregation[field] === undefined || aggregation[field] == null) {
                match = false;
                break;
              }
            }
          }
          if (match) {
            matches.push(aggregation);
            if (exactMatch)
              return matches;
          }
        }
      }
    }
    return matches;
  }

  public toPOJO(): PivotReportPOJO {
    return new PivotReportPOJO(this, null, null, null);
  }
}

class PivotData {
  raw: any[];
  aggregation: any[];
}

class Combination {
  private static printTheArray(arr: boolean[], n: number) {
    let permutation = [];
    for (let i = 0; i < n; i++) {
      permutation.push(arr[i]);
    }
    return permutation;
  }

  // Function to generate all binary strings
  private static generateAllBinaryStrings(n: number, arr: boolean[], i: number) {
    let permutations = [];
    if (i == n) {
      permutations.push(Combination.printTheArray(arr, n));
      return permutations;
    }

    // First assign "false" at ith position
    // and try for all other permutations
    // for remaining positions
    arr[i] = false;
    for (let perm of Combination.generateAllBinaryStrings(n, arr, i + 1)) {
      permutations.push(perm);
    }

    // And then assign "true" at ith position
    // and try for all other permutations
    // for remaining positions
    arr[i] = true;
    for (let perm of Combination.generateAllBinaryStrings(n, arr, i + 1)) {
      permutations.push(perm);
    }
    return permutations;
  }

  // Driver Code
  static booleanPermutations(n: number) {

    let arr: boolean[] = [];
    for (let i = 0; i < n; i++)
      arr.push(null);


    // Print all binary strings
    return Combination.generateAllBinaryStrings(n, arr, 0);
  }

  static nullPermutations(array: any[]) {
    if (!array)
      return array;
    let booleanPermutations = Combination.booleanPermutations(array.length);
    let nullPermutations = [];
    for (let permutation of booleanPermutations) {
      let entry = [];
      for (let i = 0; i < array.length; i++)
        entry[i] = permutation[i] ? array[i] : null;
      nullPermutations.push(entry);
    }
    return nullPermutations;
  }
}
